module.exports = __webpack_public_path__ + "static/media/garland.11dc7f3e.svg";